"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unregisterHttpRequestMonitorCallbacks(httpRequestMonitor) {
    httpRequestMonitor.on('bandwidth-estimate', undefined);
    httpRequestMonitor.on('timeout', undefined);
}
exports.default = unregisterHttpRequestMonitorCallbacks;
//# sourceMappingURL=unregisterHttpRequestMonitorCallbacks.js.map